import { Box, BoxProps } from "@chakra-ui/react";

import { ChildrenFC } from "src/types/types";

const Container: ChildrenFC<BoxProps> = ({ children, ...props }) => (
  <Box
    mx="auto"
    px={{ base: "20px", md: "16px" }}
    maxW={props.maxW || "900px"}
    {...props}
  >
    {children}
  </Box>
);

export default Container;
